import { RESET_STATE } from 'store/global/actions';

import { GET_ACTIVE_APPLICANTS } from '../actions';

const initialState = [];

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ACTIVE_APPLICANTS:
      return action.payload;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
